/* eslint-disable import/prefer-default-export */
export const MODAL_TYPES = {
  remind: 'remind',
  save: 'save',
  assign: 'assign',
  revoke: 'revoke',
};

export const EMAIL_TEMPLATE_GREETING_ID = 'email-template-greeting';
export const EMAIL_TEMPLATE_SUBJECT_ID = 'email-template-subject';
export const EMAIL_TEMPLATE_BODY_ID = 'email-template-body';
export const EMAIL_TEMPLATE_CLOSING_ID = 'email-template-closing';
export const EMAIL_TEMPLATE_FILES_ID = 'email-template-files';
